module.exports = __webpack_public_path__ + "media/images/lb/573-126c06a430049a818e71caa5cd0132a0.svg";